import React, { FC } from 'react';
import { SignedNumber } from '@tradingblock/components';
import { useSharedPLCalculations } from '../../hooks/useSharedPLCalculations';

export const ActivitySummaryTotals: FC = () => {
  const { totals } = useSharedPLCalculations();
  const todayPnL = totals.tradedToday.total;
  const totalPnL = totals.all.total; // Use plWorker's total P/L instead of getAllPositionInfo
  const notTradedPnL = totalPnL - todayPnL;

  return (
    <ul className="inline-list">
      <li>
        Not traded <strong>today</strong>: Daily P/L
        <SignedNumber value={notTradedPnL} format currency hideIcon />
      </li>
      <li>
        Total Daily P/L:
        <SignedNumber value={totalPnL} format currency hideIcon />
      </li>
    </ul>
  );
};
